define(["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;
  // @ts-check

  /**
   * Removes common indents across the IDL texts,
   * so that indentation inside <pre> won't affect the rendered result.
   * @param {string} text IDL text
   */
  const name = "core/reindent";
  /**
   * @param {string} text
   */

  _exports.name = name;

  function reindent(text) {
    if (!text) {
      return text;
    } // TODO: use trimEnd when Edge supports it


    const lines = text.trimRight().split("\n");

    while (lines.length && !lines[0].trim()) {
      lines.shift();
    }

    const indents = lines.filter(s => s.trim()).map(s => s.search(/[^\s]/));
    const leastIndent = Math.min(...indents);
    return lines.map(s => s.slice(leastIndent)).join("\n");
  }

  function run() {
    for (const pre of document.getElementsByTagName("pre")) {
      pre.innerHTML = reindent(pre.innerHTML);
    }
  }
});
//# sourceMappingURL=reindent.js.map